import { acceptHMRUpdate, defineStore } from "pinia";
import { reactive, toRefs } from "vue";

interface State {
  hasBanner: boolean;
}

export const useSiteStateStore = defineStore("siteState", () => {
  const state = reactive<State>({
    hasBanner: false
  });

  return {
    ...toRefs(state)
  };
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useSiteStateStore, import.meta.hot));
}
